<div class="filter-wrap" (click)="closeFilter()">
  <div class="filter-container">
    <div class="filter-condition" *ngFor="let item of subCondition;let i=index" (click)="doFilter(i,condition)">
      <div *ngIf = "item">
        <p *ngIf="condition==='状态'">{{item}}</p>
        <p *ngIf="condition==='课程'" [innerHtml]="item.version? item.version === '标准版' ? item.name : item.name + '('+ item.version.slice(0,item.version.length-1)+ ')': item.name " ></p>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/component/filter/component.filter.html